import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class UploadService {
  constructor(private api: ApiService) {}

  // ✅ Fetch all projects
  getProjects(): Observable<any[]> {
    return this.api.get<any[]>('/projects');
  }

  // ✅ Fetch modules by project ID
  getModules(projectId: string): Observable<any[]> {
    return this.api.get<any[]>(`/projects/${projectId}/modules`);
  }

  // ✅ Fetch all users
  getUsers(): Observable<any[]> {
    return this.api.get<any[]>('/users');
  }

  // ✅ Upload video + thumbnail + supporting files
  uploadVideo(formData: FormData): Observable<any> {
    return this.api.post<any>('/videos/upload', formData);
  }

  // ✅ Upload document + thumbnail + docData (Editor.js JSON)
  uploadDocument(formData: FormData): Observable<any> {
    return this.api.post<any>('/documents/upload', formData);
  }

  uploadFaq(payload: any): Observable<any> {
    return this.api.post<any>('/faq/upload', payload);
  }
}
